import sharedRequest from '@/service/sharedRequest';


// 获取视角
export function getViewAngleService(data, headers) {
    return sharedRequest.post('/userDefined/v3/VisualAngle', data, { headers });
}

/**
 * 属性查询相关 
 */

// 查询模型属性
export function getProjectParam(data, headers) {
    return sharedRequest.post('/element/v3/getElementParam', data, { headers });
}

// 查询构件属性
export function getElemParamService(data, headers) {
    return sharedRequest.post('/componentLibrary/v3/getComponentProperty', data, { headers });
}

// 查询构件属性类型
export function getElemParamTypeService(data, headers) {
    return sharedRequest.post('/componentLibrary/v3/getComponentParamTypes', data, { headers });
}

// 获取矢量属性信息
export function getVectorAttrService(data, headers) {
    return sharedRequest.post('/element/v3/getVectorParam', data, { headers });
}

// 根据分组获取目录树子节点
export function getSharedBimElemTreeNodesByGroupService(data, headers) {
    return sharedRequest.post('/dataSet/v3/rvtGroupTreeNodes', data, { headers });
}

// 获取RvtGroup节点关联的构件id
export function getSharedBimElemIdsByGroupService(data, headers) {
    return sharedRequest.post('/element/v3/getRvtGroupTreeChildren', data, { headers });
}

// 根据构件查询RvtGroup分组
export function getSharedRvtGroupByElemIdService(data, headers) {
    return sharedRequest.post('/element/v3/getRvtGroupByElem', data, { headers });
}

// 查询RvtGroup分组属性
export function getSharedRvtGroupAttrService(data, headers) {
    return sharedRequest.post('/element/v3/getRvtGroupParam', data, { headers });
}

/**
 * 视口相关
 */

// 获取视口列表
export function getSceneViewportListService(sceneId, headers) {
    return sharedRequest.get(`/scene/v3/viewport/getList/${sceneId}`, { headers });
}

// 获取视口详情
export function getSceneViewportDetailsService(viewportId, headers) {
    return sharedRequest.get(`/scene/v3/viewport/${viewportId}`, { headers });
}

/**
 * 批注相关
 */

// 获取批注列表
export function getSceneAnnotationListService(sceneId, headers) {
    return sharedRequest.get(`/scene/v3/annotation/getList/${sceneId}`, { headers });
}

// 获取锚点类型列表
export function getAnnotationTypeListService(data, headers) {
    return sharedRequest.post('/scene/v3/annotation/getTypeList', data, { headers })
}

// 获取批注详情
export function getAnnotationDetailsService(annotationId, headers) {
    return sharedRequest.get(`/scene/v3/annotation/${annotationId}`, { headers });
}

// 查询批注附件列表
export function getAnnotationAttachmentListService(annotationId, headers) {
    return sharedRequest.get(`/scene/v3/annotation/getAttachments/${annotationId}`, { headers });
}

// 查询批注评论列表
export function getAnnotationCommentListService(data, headers) {
    return sharedRequest.post('/scene/v3/annotation/getPagedComments', data, { headers });
}

/**
 * 锚点相关
 */

// 获取锚点列表
export function getSceneAnchorListService(sceneId, headers) {
    return sharedRequest.get(`/scene/v3/anchorPoint/getList/${sceneId}`, { headers });
}

// 获取锚点类型列表
export function getAnchorTypeListService(data, headers) {
    return sharedRequest.post('/scene/v3/anchorPoint/getTypeList', data, { headers })
}

// 获取锚点详情
export function getAnchorDetailsService(anchorPointId, headers) {
    return sharedRequest.get(`/scene/v3/anchorPoint/${anchorPointId}`, { headers });
}

// 查询锚点附件列表
export function getAnchorAttachmentListService(anchorPointId, headers) {
    return sharedRequest.get(`/scene/v3/anchorPoint/getAttachments/${anchorPointId}`, { headers });
}

// 查询锚点评论列表
export function getAnchorCommentListService(data, headers) {
    return sharedRequest.post('/scene/v3/anchorPoint/getPagedComments', data, { headers });
}

/**
 * 漫游相关
 */

// 获取漫游列表
export function getRoamList(id, headers) {
    return sharedRequest.get(`/scene/v3/Roam/GetList/${id}`, { headers })
}

// 获取漫游详情
export function getRoamDetails(id, headers) {
    return sharedRequest.get(`/scene/v3/Roam/${id}`, { headers })
}